import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import { Flex, Space, Button, DatePicker, Modal, Input, Tag, Row, Col, Card } from "antd";
import { useSelector } from "react-redux";
import { ReactComponent as DownloadIcon } from "../../../assets/icon/downloadIcon.svg";
import ModalWorkinClockingIn from "components/elements/Modal/ModalWorkinClockingIn";
import localeTh from 'antd/es/date-picker/locale/th_TH';
import localeEn from 'antd/es/date-picker/locale/en_US';
import ModalMyRequest from "components/elements/Modal/ModalMyRequest";


function EmployeeWorkInWorkIn({
  isLoading = false,
  onDownload = () => { },
  getTable = () => { },
  handleApply = () => { },
  handleDateChange = () => { },
  modalData = {},
  modalProps = {},
  isModalOpen = false,
  onCancel = () => { },
  visible = false,
  modalType = {},
  handleClose = () => { },
  work = [],
  title = {},
  isModalClockingOpen,
  setIsModalClockingOpen = () => { }
}) {
  const { t, i18n } = useTranslation();
  // const isLoading = useSelector((state) => state.employee.isLoading)
  const { RangePicker } = DatePicker;
  // console.log("modalData", modalData)

  function localeFn() {
    if (i18n.language === 'en') {
      return localeEn
    } else {
      return {
        ...localeTh,
        lang: {
          ...localeTh.lang,
          yearFormat: "BBBB",
          dateFormat: "D/M/BBBB",
          cellYearFormat: "BBBB"
        }
      }
    }
  }

  return (
    <Space style={{ width: "100%" }} size={24} direction="vertical">
      <Flex justify="space-between" align="end">
        <Flex gap={16} align="end">
          <Flex vertical>
            <label>{t("workin.label.date_employed")}</label>
            <RangePicker
              name="employedStartDate"
              placeholder={[t("workin.label.date_employed"), ""]}
              defaultValue={[dayjs().startOf('month'), dayjs()]}
              format={i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB"}
              onChange={handleDateChange}
              disabledDate={(currentDate) => currentDate.isBefore(dayjs("2024-01-01"))}
              size="large"
              locale={localeFn()}
            />
          </Flex>

          <Button type="primary" onClick={handleApply}
            style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" }} size="large">
            {t("translation.search")}
          </Button>
        </Flex>

        <Button type="default" disabled={isLoading} onClick={onDownload}
          style={{ height: "40px", borderRadius: "8px" }} size="large"
        >
          <Flex align="center" justify="center" gap={8}>
            <DownloadIcon />
            <span style={{ color: "#667085", fontWeight: "bold", fontSize: "14px" }}>{t('common.download')}</span>
          </Flex>
        </Button>
      </Flex>

      {getTable()}
      <ModalWorkinClockingIn isLoading={isLoading} work={work} title={title} isModalClockingOpen={isModalClockingOpen} setIsModalClockingOpen={setIsModalClockingOpen} />
      <ModalMyRequest
        {...modalProps}
        isModalOpen={isModalOpen}
        onCancel={onCancel}
      />
      {/* <Modal
        onCancel={handleClose}
        footer={null}
        open={visible}
        title={
          modalType === "leave" ? "เอกสารคำขอลางาน" :
            modalType === "overtime" ? "เอกสารคำขอทำงานล่วงเวลา" :
              modalType === "offsite" ? "เอกสารคำขอปฏิบัติงานนอกสถานที่" :
                modalType === "endorseTime" ? "เอกสารคำขอรับรองเวลา" : "เอกสาร"
        }
        centered
        width={700}
      >
        <div style={{ padding: "16px" }}>
          <Tag color="green" style={{ fontSize: "14px", padding: "4px 12px", borderRadius: "16px" }}>
            {modalData?.approveStatus || "อนุมัติแล้ว"}
          </Tag>

          <Row gutter={[16, 8]} style={{ marginTop: "16px" }}>
            <Col span={12}>
              <span >เลขที่เอกสาร</span> <span>{modalData?.sequence}</span>
            </Col>
            <Col span={12}>
              <span >วันที่สร้างเอกสาร</span> <span>{dayjs(modalData?.createDate).format(i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB")}</span>
            </Col>
            <Col span={12}>
              <span >ผู้สร้างเอกสาร</span> <span>{modalData?.createBy?.nameAndSurname}</span>
            </Col>
            <Col span={12}>
              <span >วันที่อนุมัติเอกสาร</span> <span>{modalData?.timeline?.at(-1).date ? dayjs(modalData?.timeline?.at(-1).date).format(i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB") : '-'}</span>
            </Col>
            <Col span={12}>
              <span >ผู้อนุมัติเอกสาร</span> <span>{modalData?.timeline?.at(-1).employee?.nameAndSurname ?? '-'}</span>
            </Col>
          </Row>
          {/* {dayjs(title?.date).format(i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB")} */}

      {/* {modalType === "leave" && (
            <Row gutter={[16, 8]} style={{ marginTop: "16px" }}>
              <Col span={12}>
                <span >วันที่เริ่มต้น</span>
                <Input value={dayjs(modalData?.startDate).format(i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB")} readOnly />
              </Col>
              <Col span={12}>
                <span >วันที่สิ้นสุด</span>
                <Input value={dayjs(modalData?.endDate).format(i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB")} readOnly />
              </Col>
              <Col span={12}>
                <span >ประเภทการลา</span>
                <Input value={modalData?.leaveType?.leaveTypeName} readOnly />
              </Col>
              <Col span={12}>
                <span >กะงาน</span>
                <Input value={title?.shiftName} readOnly />
              </Col>
            </Row>
          )}

          {modalType === "overtime" && (
            <Row gutter={[16, 8]} style={{ marginTop: "16px" }}>
              <Col span={12}>
                <span >เวลาที่เริ่มทำงานล่วงเวลา</span>
                <Input value={modalData?.startTime} readOnly />
              </Col>
              <Col span={12}>
                <span >เวลาที่สิ้นสุดทำงานล่วงเวลา</span>
                <Input value={modalData?.endTime} readOnly />
              </Col>
            </Row>
          )}

          {modalType === "offsite" && (
            <Row gutter={[16, 8]} style={{ marginTop: "16px" }}>
              <Col span={12}>
                <span >วันที่เริ่มต้น</span>
                <Input value={dayjs(modalData?.startDate).format(i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB")} readOnly />
              </Col>
              <Col span={12}>
                <span >วันที่สิ้นสุด</span>
                <Input value={dayjs(modalData?.endDate).format(i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB")} readOnly />
              </Col>
              <Col span={24} style={{ marginTop: "16px" }}>
                <span >สถานที่</span>
                <Input value={modalData?.location} readOnly />
              </Col>
            </Row>
          )}

          {modalType === "endorseTime" && (
            <Row gutter={[16, 8]} style={{ marginTop: "16px" }}>
              <Col span={12}>
                <span >วันที่รับรอง</span>
                <Input value={dayjs(modalData?.endorseMentDate).format(i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB")} readOnly />
              </Col>
              <Col span={12}>
                <span >ช่วงเวลา</span>
                <Input value={`${modalData?.startTime} - ${modalData?.endTime}`} readOnly />
              </Col>
            </Row>
          )}

          <Row gutter={[16, 8]} style={{ marginTop: "16px" }}>
            <Col span={24}>
              <span >เหตุผล</span>
              <Input value={modalData?.description} readOnly />
            </Col>
          </Row>

          {modalData?.attachFile?.length > 0 && (
            <Row gutter={[16, 8]} style={{ marginTop: "16px" }}>
              <Col span={24}>
                <span >ไฟล์แนบ</span>
                <Card
                  style={{
                    marginTop: "8px",
                    border: "1px solid #E0E0E0",
                    borderRadius: "8px",
                    backgroundColor: "#F9FAFB"
                  }}
                >
                  <Row justify="space-between" align="middle">
                    <Col>
                      <span >เอกสารแนบ</span>
                      <span style={{ marginLeft: "8px" }}>{modalData?.fileType ?? "ไฟล์แนบ"}</span>
                    </Col>
                    <Col>
                      <Button type="primary" icon={<DownloadIcon />} size="small">
                        ดาวน์โหลด
                      </Button>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          )}
        </div>
      </Modal>  */}
    </Space>
  );
}

export default EmployeeWorkInWorkIn;
